import type { JSX } from "react";

const MAP = {
  healthy: { tone: "ok", text: "正常" },
  degraded: { tone: "warn", text: "降级" },
  critical: { tone: "err", text: "严重" }
} as const;

export function HealthBadge({ status }: { status: "healthy" | "degraded" | "critical" }): JSX.Element {
  const m = MAP[status];
  return <span className={`cc-health cc-health-${m.tone}`}><span className="cc-dot" />{m.text}</span>;
}
